import Progress from '../progress/progress';
import { palette } from '@instamenu/ui-vanilla-extract';

export function ChartLoading() {
  return (
    <div
      style={{
        border: `1px solid $${palette.gray50}`,
        padding: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Progress size={32} />
      <div style={{ fontSize: 16, fontWeight: 700, marginTop: 16 }}>Loading Data</div>
    </div>
  );
}

export default ChartLoading;
